import {ProcessedData, StatusCount, StatusDetails, TagDataInstance} from '../types';

export function stripPrefix(value: string): string {
  const valueStr = value.toString(); // Convert the number to a string
  if (valueStr.startsWith('10')) {
    // Check if it starts with '10'
    return valueStr.slice(2); // Remove the first two characters and convert back to number
  }
  return value; // If it doesn't start with '10', return the original value
}

export const processDataAndCalculateAverages = (
  data: TagDataInstance[],
): ProcessedData => {
  const vehicleMap: Map<
    number,
    {
      rssiSum: number;
      count: number;
      vehicleid: number;
      items: TagDataInstance;
      signalAverage: StatusCount;
    }
  > = new Map();
  data.forEach((item: any) => {
    const oldVehicleId = stripPrefix(item.eventData.old_vehicle_id.toString());
    const rssi = item.eventData.udp_packets.rssi;
    const statusCounts: StatusDetails = {warning: 0, alert: 0, good: 0};
    if (!vehicleMap.has(oldVehicleId)) {
      vehicleMap.set(oldVehicleId, {
        rssiSum: 0,
        count: 0,
        vehicleid: oldVehicleId,
        items: [],
        signalAverage: statusCounts,
      });
    }
    const vehicleData = vehicleMap.get(oldVehicleId)!;
    const averageRssi = rssi / vehicleData.count;
    if (averageRssi > -75) {
      vehicleData.signalAverage.alert += 1;
    } else if (averageRssi > -65) {
      vehicleData.signalAverage.alert += 1;
    } else {
      vehicleData.signalAverage.good += 1;
    }
    vehicleData.rssiSum += rssi;
    vehicleData.count += 1;
    vehicleData.items.push(item);
  });
  const statusCounts: StatusDetails = {warning: 0, alert: 0, good: 0};
  Array.from(vehicleMap.values()).forEach((vehicleData) => {
    const averageRssi = vehicleData.rssiSum / vehicleData.count;
    if (averageRssi > 75) {
      statusCounts.warning += 1;
    } else if (averageRssi > 65) {
      statusCounts.alert += 1;
    } else {
      statusCounts.good += 1;
    }
  });
  const totalVehicles = statusCounts.warning + statusCounts.alert + statusCounts.good;
  const averageCounts = {
    warning: totalVehicles > 0 ? statusCounts.warning / totalVehicles : 0,
    alert: totalVehicles > 0 ? statusCounts.alert / totalVehicles : 0,
    good: totalVehicles > 0 ? statusCounts.good / totalVehicles : 0,
  };

  // Convert map values to an array and sort by server_timestamp
  const distinctObjects = Array.from(vehicleMap.values()).sort((a, b) => {
    const bFirstItem = b.items[0]; // Explicitly access the first item
    const aFirstItem = a.items[0];

    // Ensure `bFirstItem` and `aFirstItem` exist before accessing their properties
    if (bFirstItem && aFirstItem) {
      return (
        new Date(bFirstItem.eventData.server_timestamp).getTime() -
        new Date(aFirstItem.eventData.server_timestamp).getTime()
      );
    }

    // If either is missing, treat it as less important
    return bFirstItem ? -1 : aFirstItem ? 1 : 0;
  });
  return {
    distinctObjects,
  };
};
